<template>
    <div class="relative">
        <div v-if="label" class="mb-2">{{ label }}</div>
        <div class="flex justify-between items-center" @click="openDropdown" :class="[disable ? 'text-light-gray' : 'cursor-pointer']">
            <span class="flex items-center w-full" :class="{ 'text-red': open }">
                <slot name="title" :open="open">{{ activeTitle }}</slot>
                <icon v-if="showIcon" name="chevron-up"
                      class="w-4 h-4 flex-shrink-0 transition-transform transform origin-center stroke-current ml-1"
                      :class="{'rotate-180': !open}"
                />
            </span>
        </div>
        <collapse-transition>
            <div v-show="open"
                 class="overflow-y-auto overflow-x-hidden absolute top-full z-30 min-w-max bg-white shadow"
                 :class="[alignment === 'left' ? 'left-0' : 'right-0', fullWidth ? 'w-full' : 'pr-8', shortHeight ? 'max-h-96 px-2 py-3' : 'max-h-42 scrollbar-thin']">
                <slot />
            </div>
        </collapse-transition>
        <slot name="selection" :value="activeValue" />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Provide } from 'vue-property-decorator';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import Icon from './Icon.vue';

@Component({
    components: { Icon, CollapseTransition }
})
export default class Dropdown extends Vue {
    @Provide('register') childRegistration = this.registerItem;
    @Prop() label: string;
    @Prop({ default: 'left' }) alignment: 'left' | 'right';
    @Prop({ default: false, type: Boolean }) contrast: boolean;
    @Prop({ default: false }) form: boolean;
    @Prop({ default: false }) fullWidth: boolean;
    @Prop({ default: true }) shortHeight: boolean;
    @Prop({ default: false, type: Boolean }) showIcon: boolean;
    @Prop({ default: false }) disable: boolean;
    @Prop({ default: '' }) title!: string;

    open = false;
    activeTitle = this.title;
    activeValue = '';
    items = [];

    mounted() {
        document.addEventListener('click', this.onOutsideClick);
    }

    beforeDestroy() {
        document.removeEventListener('click', this.onOutsideClick);
    }

    // open/close dropdown
    openDropdown() {
        if (!this.disable) {
            this.open = !this.open;
        }
    }

    // called by child items
    registerItem(item) {
        item.contrast = this.contrast;
        this.items.push(item);
        item.$on('click', ({ label, value }) => {
            this.activeTitle = this.activeTitle === label ? this.title : label;
            this.activeValue = this.activeValue === value ? '' : value;
            this.$emit('select', { label, value });
            this.open = false;
        });
    }

    onOutsideClick(evt) {
        let targetElement = evt.target;

        do {
            if (targetElement === this.$el) {
                return;
            }
            targetElement = targetElement.parentNode;
        } while (targetElement);
        this.open = false;
    }
}
</script>
